import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { UpdateIndicatorResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateIndicatorResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type UpdateIndicatorResultInput = {
  id: string;
  Description?: string | null;
  ResultDate: string;
  TargetValueNum?: number | null;
  TargetValueTxt?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateIndicatorResult = createMutationHook({
  name: 'updateIndicatorResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.indicator.updateResult.mutationOptions({ onSuccess }),
  mapInput: ({ id, ...rest }: UpdateIndicatorResultInput) => ({
    Id: id,
    ...rest,
  }),
  invalidate: (trpc) => [
    trpc.frontend.indicator.indicatorResultsByIndicatorId.queryKey(),
  ],
  mapResponse: (result: { Id: string }): UpdateIndicatorResultMutation => ({
    update_indicator_result: {
      __typename: 'indicator_result_mutation_response',
      returning: [
        {
          __typename: 'indicator_result',
          Id: result.Id,
        },
      ],
    },
  }),
  graphqlDocument: UpdateIndicatorResultDocument,
  graphqlVariables: (input: UpdateIndicatorResultInput) => ({ ...input }),
  evictFields: ['indicator_result', 'indicator'],
});
